/* eslint-disable eqeqeq */
/* eslint-disable eqeqeq */
import SmallBoxChart from "./SmallBoxChart";

const Tree = (data, type, elem, isShowFullnameAndPosition) => {
  let details = data.details;
  let childs = { ...data.childs };
  let user_depts = data.user_depts;
  let user_details = data.user_details;
  let queues = [elem];
  let level = 0;
  let content_list = [];
  //let is_hide_division = (type == "hybrid" && elem == 10) ? true : false;
  let is_hide_division = type == "functional" && elem == 1 ? true : false;
  //console.log("elem=" + elem + ", is_hide_division=" + is_hide_division);
  while (elem != null && elem != "" && queues.length > 0) {
    level++;
    //console.log("elem=" + elem + ", level=" + level, user_depts[elem]);
    // console.log("elem=", details[elem]);
    let addClass = "";
    if (details[elem].name === "EXO Travel") {
      addClass += " is-exo-travel";
    } else if (details[elem].name === "EXO Group") {
      addClass += " is-exo-group";
    }

    content_list.push(`<li class="li-dept${addClass}">`);
    content_list.push(
      SmallBoxChart(
        details[elem],
        elem in user_depts ? user_depts[elem] : [],
        user_details,
        type,
        {
          exclude_top_level: false,
          level: level,
          elem_id: elem,
          count_child_dept:
            elem in data["childs"] ? data["childs"][elem].length : 0,
          is_hide_division: is_hide_division,
          isShowFullnameAndPosition }
      )
    );

    if (elem in childs && childs[elem].length > 0) {
      let before_elem = elem;
      let ol_class = "";
      let ol_css = "";
      if (elem in data["childs"] && data["childs"][elem].length > 0) {
        ol_class = "sub-dept-" + elem;
        ol_css =
          is_hide_division &&
          "level_id" in details[elem] &&
          details[elem]["level_id"] >= 1
            ? "display: none;"
            : "";
      }
      queues.unshift(childs[elem][0]);
      elem = queues[0];
      content_list.push(`<ol class='` + ol_class + `' style='` + ol_css + `'>`);
      // Add staff under before department
      if (type == "hybrid" && before_elem in user_depts) {
        //console.log("user_dept", before_elem, user_depts[before_elem]);
        content_list.push(
          SmallBoxChart(
            details[before_elem],
            user_depts[before_elem],
            user_details,
            "staff",
            {
              exclude_top_level: true,
              level: level,
              isShowFullnameAndPosition }
          )
        );
      }
      // END Add staff under before department
      continue;
    }
    // Add end tag for display staff
    if (type == "hybrid" && elem in user_depts && user_depts[elem]) {
      const tmp_content = SmallBoxChart(
        details[elem],
        user_depts[elem],
        user_details,
        "staff",
        {
          exclude_top_level: true,
          level: level,
          isShowFullnameAndPosition }
      );
      if (tmp_content != "") {
        let ol_class = "sub-dept-" + elem;
        let ol_css =
          is_hide_division &&
          "level_id" in details[elem] &&
          details[elem]["level_id"] >= 1
            ? "display: none;"
            : "";
        content_list.push(
          `<ol class='` +
            ol_class +
            `' style='` +
            ol_css +
            `'>` +
            tmp_content +
            `</ol>`
        );
      }
    }
    // END Add end tag for display staff
    content_list.push(`</li>`);
    // Find next elem and have child
    let next_elem = null;
    let tmp_queues = [...queues];
    for (let i in tmp_queues) {
      let queue = tmp_queues[i];
      if (queue in childs && childs[queue].length > 0) {
        queues.unshift(childs[queue][0]);
        next_elem = queues[0];
        break;
      }
      if (elem != queue) {
        /*if(type == "hybrid" && queue in user_depts) {
                    content_list.push(Feature.SmallBoxChart(details[queue], user_depts[queue], user_details, "staff", {
                        exclude_top_level: true,
                        level: level
                    }));
                }*/
        content_list.push(`</ol></li>`);
      }
      queues.shift();
      const parent_queue = details[queue]["parent"];
      if (parent_queue == null) {
        break;
      }
      if (parent_queue in childs && childs[parent_queue].length > 0) {
        const tmp_childs = childs[parent_queue].filter((item) => item != queue);
        childs[parent_queue] = tmp_childs;
      }
      level--;
    }
    elem = next_elem;
  }
  return content_list;
};

export default Tree;

